export * as dev from './lib/environment';
export * as prod from './lib/prod/environment.prod';
export * as staging from './lib/staging/environment.staging';

export * from './lib/environment';
